import React from 'react'

const Postage = () => {
    return (
        <div>Postage</div>
    )
}

export default Postage